import { defineComponent as W, ref as m, toRefs as ee, computed as a, withDirectives as N, openBlock as n, createElementBlock as g, normalizeStyle as Te, normalizeClass as y, vModelDynamic as Ee, renderSlot as C, watch as _, resolveComponent as i, createVNode as L, createSlots as Pe, withCtx as b, createTextVNode as T, toDisplayString as E, createElementVNode as z, vShow as Z, createBlock as k, createCommentVNode as j, Fragment as F, getCurrentInstance as Le, nextTick as Re, resolveDirective as de, withModifiers as Y, renderList as H } from "vue";
import { DropdownClose as De, DropdownOpen as Fe } from "@onereach/ui-components-common/directives";
import { searchItemsByLabel as Ue } from "@onereach/ui-components-common/helpers";
import { useProxyModelValue as oe, useResponsive as ze } from "@onereach/ui-components-common/hooks";
import { isNil as Ne, toArray as x, isEqual as pe, isEmpty as ce, include as ie, exclude as ue } from "@onereach/ui-components-common/utils";
import { O as qe } from "./OrCheckbox-CI-mxgEp.mjs";
import { O as Ae } from "./OrError-B5ihH6-3.mjs";
import { O as He } from "./OrExpansionPanel-BNGPdEnp.mjs";
import { O as je } from "./OrHint-NvbZyURY.mjs";
import { O as We } from "./OrIconButton-BlHCLpeW.mjs";
import { O as Ge } from "./OrIcon-k8cyvh-D.mjs";
import { O as Je } from "./OrInputBox-6ciokFdU.mjs";
import { a as Ke } from "./OrInputBox.vue_vue_type_script_lang-q2L7rmth.mjs";
import { O as Qe } from "./OrInput-DBcNZlkx.mjs";
import { O as Xe } from "./OrLabel-DssheqEn.mjs";
import { O as Ye } from "./OrMenuItem-BHRMA0L1.mjs";
import { O as Ze } from "./OrPopover-DbygLPtT.mjs";
import { O as xe, T as ae } from "./OrTags-CS0bcLtx.mjs";
import { O as _e } from "./OrLoader-2SaTMxmZ.mjs";
import { useFocus as eo } from "@vueuse/core";
import { _ as G } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
import { O as oo } from "./OrTooltip-DqwjoE82.mjs";
const lo = [
  // Base
  "appearance-none",
  // Typography
  "typography-inherit",
  // Theme (placeholder)
  "placeholder:theme-foreground-outline",
  "dark:placeholder:theme-foreground-outline-dark",
  "theme-background-transparent",
  "outline-none"
], to = W({
  name: "OrSelectControlInput",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue"
  ],
  expose: [
    "root",
    "focus",
    "focused"
  ],
  setup(e, o) {
    const w = m(), { placeholder: f, modelValue: v } = ee(e), u = oe(v, o.emit), { focused: p } = eo(w), h = a(() => [
      ...lo
    ]), O = a(() => {
      var M;
      const S = u.value.length > 0 ? u.value.length : (M = f.value) == null ? void 0 : M.length;
      return {
        width: `${Math.max(S + 1 || 0, 2)}ch`
      };
    });
    function s() {
      p.value = !0;
    }
    return {
      root: w,
      proxyModelValue: u,
      controlStyles: h,
      controlInlineStyles: O,
      focused: p,
      focus: s
    };
  }
}), ao = ["placeholder", "readonly", "disabled"];
function no(e, o, w, f, v, u) {
  return N((n(), g("input", {
    ref: "root",
    "onUpdate:modelValue": o[0] || (o[0] = (p) => e.proxyModelValue = p),
    style: Te(e.controlInlineStyles),
    class: y(e.controlStyles),
    type: "text",
    placeholder: e.placeholder,
    readonly: e.readonly,
    disabled: e.disabled,
    autocomplete: "off",
    minlength: void 0,
    maxlength: void 0
  }, null, 14, ao)), [
    [Ee, e.proxyModelValue]
  ]);
}
const me = /* @__PURE__ */ G(to, [["render", no]]), ro = [
  // Interactivity
  "interactivity-default",
  // Typography
  "typography-inherit truncate",
  // Theme
  "theme-foreground-outline",
  "dark:theme-foreground-outline-dark"
], so = W({
  name: "OrSelectPlaceholder",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  expose: [
    "root"
  ],
  setup() {
    const e = m(), o = a(() => [
      "or-select-placeholder-v3",
      ...ro
    ]);
    return {
      root: e,
      rootStyles: o
    };
  }
}), io = ["disabled"];
function uo(e, o, w, f, v, u) {
  return n(), g("div", {
    ref: "root",
    class: y(e.rootStyles),
    disabled: e.disabled
  }, [
    C(e.$slots, "default")
  ], 10, io);
}
const fe = /* @__PURE__ */ G(so, [["render", uo]]), po = [
  // Layout
  "layout-row",
  "w-full"
], co = W({
  name: "OrSelectMultipleControl",
  components: {
    OrSelectPlaceholder: fe,
    OrSelectControlInput: me,
    OrTags: xe
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    model: {
      type: void 0,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    overflow: {
      type: String,
      default: () => ae.Hidden
    },
    placeholder: {
      type: String,
      default: void 0
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    enableSearch: {
      type: Boolean,
      default: !1
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue",
    "reset"
  ],
  expose: [
    "root",
    "focus",
    "focused"
  ],
  setup(e, o) {
    const w = m(), f = m(), v = m(), { modelValue: u, model: p, options: h, overflow: O } = ee(e), s = oe(u, o.emit), S = a(() => {
      var c;
      return (c = f.value) == null ? void 0 : c.focused;
    }), M = a(() => [
      "or-select-multiple-control-v3",
      ...po
    ]), I = a(() => Ne(p.value) ? [] : x(p.value)), P = a(() => I.value.length === 0), $ = a(() => p.value === void 0 || p.value === null ? [] : I.value.map((c) => h.value.find((B) => pe(B.value, c))).filter((c) => !!c).map((c) => ({
      value: c.value,
      label: c.label,
      tagProps: c.disabled && { disabled: c.disabled }
    })));
    _($, (c, B) => {
      c.length != B.length && O.value === ae.Scroll && v.value && v.value.scrollToEnd();
    });
    function U() {
      f.value && f.value.focus();
    }
    return {
      root: w,
      tags: v,
      rootStyles: M,
      searchControl: f,
      searchModelValue: s,
      isEmpty: P,
      selection: $,
      value: I,
      focus: U,
      focused: S
    };
  }
}), mo = { class: "inline-flex w-fit max-w-full" };
function fo(e, o, w, f, v, u) {
  const p = i("OrSelectControlInput"), h = i("OrTags"), O = i("OrSelectPlaceholder");
  return n(), g("div", {
    ref: "root",
    class: y(e.rootStyles)
  }, [
    N(L(h, {
      ref: "tags",
      items: e.selection,
      class: "grow",
      disabled: e.disabled,
      "tag-props": {
        variant: e.readonly || e.disabled ? "tag" : "reset",
        disabled: e.disabled
      },
      overflow: e.overflow,
      onReset: o[1] || (o[1] = (s) => e.$emit("reset", s))
    }, Pe({
      tag: b(({ item: s }) => [
        C(e.$slots, "tag", { item: s }, () => [
          T(E(s.label), 1)
        ])
      ]),
      _: 2
    }, [
      e.enableSearch ? {
        name: "tail",
        fn: b(() => [
          z("div", mo, [
            L(p, {
              ref: "searchControl",
              modelValue: e.searchModelValue,
              "onUpdate:modelValue": o[0] || (o[0] = (s) => e.searchModelValue = s),
              placeholder: e.isEmpty ? e.placeholder : "",
              readonly: e.readonly,
              disabled: e.disabled
            }, null, 8, ["modelValue", "placeholder", "readonly", "disabled"])
          ])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["items", "disabled", "tag-props", "overflow"]), [
      [Z, !e.isEmpty || e.enableSearch]
    ]),
    e.isEmpty && !e.enableSearch ? (n(), k(O, {
      key: 0,
      disabled: e.disabled
    }, {
      default: b(() => [
        T(E(e.placeholder), 1)
      ]),
      _: 1
    }, 8, ["disabled"])) : j("", !0)
  ], 2);
}
const vo = /* @__PURE__ */ G(co, [["render", fo]]), yo = [
  // Layout
  "w-full"
], bo = W({
  name: "OrSelectSingleControl",
  components: {
    OrSelectPlaceholder: fe,
    OrSelectControlInput: me,
    OrTooltip: oo
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    model: {
      type: void 0,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    enableSearch: {
      type: Boolean,
      default: !1
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue"
  ],
  expose: [
    "root",
    "focus",
    "focused"
  ],
  setup(e, o) {
    const w = m(), f = m(), v = m(), u = m(), { modelValue: p, model: h, options: O } = ee(e), s = oe(p, o.emit), S = a(() => ce(h.value)), M = a(() => O.value.find((r) => pe(r.value, h.value))), I = a(() => {
      var r;
      return (r = M.value) == null ? void 0 : r.label;
    });
    _(
      () => e.isOpen,
      () => {
        var r;
        (r = u.value) == null || r.close();
      }
    );
    const P = a(() => {
      var r;
      return (r = f.value) == null ? void 0 : r.focused;
    }), $ = () => {
      u.value && u.value.open();
    }, U = () => {
      u.value && u.value.close();
    }, c = a(() => [
      "or-select-single-control-v3",
      ...yo
    ]);
    function B() {
      f.value && f.value.focus();
    }
    function q() {
      if (!v.value)
        return;
      v.value.scrollWidth > v.value.clientWidth && $();
    }
    return {
      root: w,
      rootStyles: c,
      searchControl: f,
      searchModelValue: s,
      isEmptyModelValue: S,
      selection: M,
      selectionLabel: I,
      focus: B,
      focused: P,
      selectionLabelRef: v,
      tooltipRef: u,
      openTooltip: $,
      closeTooltip: U,
      checkTooltip: q
    };
  }
}), ho = {
  key: 1,
  class: "flex"
};
function So(e, o, w, f, v, u) {
  const p = i("OrSelectControlInput"), h = i("OrSelectPlaceholder"), O = i("OrTooltip");
  return n(), g("div", {
    ref: "root",
    class: y(e.rootStyles)
  }, [
    e.isOpen && e.enableSearch ? (n(), k(p, {
      key: 0,
      ref: "searchControl",
      modelValue: e.searchModelValue,
      "onUpdate:modelValue": o[0] || (o[0] = (s) => e.searchModelValue = s),
      placeholder: e.isEmptyModelValue ? e.placeholder : e.selectionLabel
    }, null, 8, ["modelValue", "placeholder"])) : (n(), g(F, { key: 1 }, [
      e.isEmptyModelValue ? (n(), k(h, {
        key: 0,
        disabled: e.disabled
      }, {
        default: b(() => [
          T(E(e.placeholder), 1)
        ]),
        _: 1
      }, 8, ["disabled"])) : (n(), g("div", ho, [
        z("div", {
          ref: "selectionLabelRef",
          class: "truncate w-full",
          onMouseenter: o[1] || (o[1] = (...s) => e.checkTooltip && e.checkTooltip(...s)),
          onMouseleave: o[2] || (o[2] = (...s) => e.closeTooltip && e.closeTooltip(...s))
        }, E(e.selectionLabel), 545),
        L(O, {
          ref: "tooltipRef",
          content: e.selectionLabel,
          trigger: e.selectionLabelRef
        }, null, 8, ["content", "trigger"])
      ]))
    ], 64))
  ], 2);
}
const go = /* @__PURE__ */ G(bo, [["render", So]]), Oo = [
  // Layout
  "layout-column",
  // Spacing
  "gap-xs"
], Vo = [
  // Layout
  "layout-row",
  "w-full",
  // Layout (empty)
  "empty:hidden",
  // Overflow
  "overflow-hidden",
  // Spacing
  "gap-xs",
  // Typography
  "typography-inherit"
], ko = [
  // Spacing
  "!mx-lg md:!-mx-sm+",
  "!my-sm md:!my-0"
], wo = [
  // Overflow
  "overflow-y-auto",
  // Box
  "max-h-[172px]",
  // equals 5 items
  // Theme
  "theme-background-default",
  "dark:theme-background-default-dark",
  "theme-border-outline border-1",
  "dark:theme-border-outline-dark"
], Co = [
  // Shape
  "rounded-b-md",
  // Theme
  "!border-t-0"
], $o = [
  // Shape
  "rounded-t-md",
  // Theme
  "!border-b-0"
], Mo = [
  // Typography
  "!typography-body-2-regular",
  // Padding Override todo: check design
  "md:!pt-[6px] md:!pb-[7px]",
  // Typography (selected)
  "selected:!typography-body-2-semibold",
  // Theme
  "!theme-foreground-default dark:!theme-foreground-default-dark"
], Io = [
  // Padding Override
  "!py-md md:!pt-[6px] md:!pb-[7px]"
], Bo = [
  // Padding Override
  "md:!pt-[6px] md:!pb-[7px]"
], To = [
  // Padding Override
  "px-md"
], Eo = [
  // Layout
  "layout-row justify-center",
  // Spacing
  "px-md",
  "py-md",
  // Typography
  "typography-caption-regular",
  // Theme
  "theme-foreground-outline",
  "dark:theme-foreground-outline-dark"
], Po = [
  // Layout
  "w-fit",
  // Typography
  "typography-body-2-regular",
  // Theme
  "text-outline dark:text-outline-dark"
], Lo = W({
  name: "OrSelect",
  components: {
    OrCheckbox: qe,
    OrError: Ae,
    OrExpansionPanel: He,
    OrHint: je,
    OrIcon: Ge,
    OrIconButton: We,
    OrInput: Qe,
    OrInputBox: Je,
    OrLabel: Xe,
    OrMenuItem: Ye,
    OrPopover: Ze,
    OrSelectMultipleControl: vo,
    OrSelectSingleControl: go,
    OrLoader: _e
  },
  directives: {
    DropdownClose: De,
    DropdownOpen: Fe
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    searchOptions: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    overflow: {
      type: String,
      default: () => ae.Hidden
    },
    variant: {
      type: String,
      default: void 0
    },
    size: {
      type: String,
      default: void 0
    },
    anchor: {
      type: Object,
      default: void 0
    },
    label: {
      type: String,
      default: void 0
    },
    placeholder: {
      type: String,
      default: void 0
    },
    hint: {
      type: String,
      default: void 0
    },
    error: {
      type: [String, Boolean],
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingText: {
      type: String,
      default: "Loading"
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    enableSearch: {
      type: Boolean,
      default: !1
    },
    enableClear: {
      type: Boolean,
      default: !1
    },
    searchFunction: {
      type: Function,
      default: Ue
    },
    groupByFunction: {
      type: Function,
      default: void 0
    },
    externalControl: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue",
    "focus",
    "blur",
    "search"
  ],
  expose: [
    "root",
    "open",
    "close",
    "toggle",
    "toggleOption",
    "resetSearch",
    "popover",
    "popoverState"
  ],
  setup(e, o) {
    const w = Le(), f = m(), v = m(), u = a(() => {
      var l;
      return (l = v.value) == null ? void 0 : l.root;
    }), p = m(), h = m(), O = m(), s = m(), S = m(), M = a(() => {
      var l;
      return (l = S.value) == null ? void 0 : l.root;
    }), I = a(() => {
      var l;
      return (l = S.value) == null ? void 0 : l.state;
    }), P = a(() => I.value === "open"), { enableClear: $, enableSearch: U, modelValue: c, multiple: B } = ee(e), q = m(o.attrs.id ?? w.uid.toString()), r = oe(c, o.emit), le = a(() => {
      var l, V;
      return (V = (l = S.value) == null ? void 0 : l.bottomSheet) == null ? void 0 : V.fullscreen;
    }), J = a(() => ce(r.value)), t = a(() => $.value && !J.value), R = a(() => {
      var l, V;
      return B.value ? (l = h.value) == null ? void 0 : l.focused : (V = O.value) == null ? void 0 : V.focused;
    }), d = a(() => o.attrs.readonly), D = m(e.options), K = a(() => e.externalControl ? e.searchOptions : D.value), te = m("");
    _([
      () => e.externalControl,
      te,
      () => e.options
    ], async ([l, V, X]) => {
      l ? o.emit("search", V) : D.value = await e.searchFunction(V, X);
    }, { deep: !0 }), _(P, (l) => {
      l || Q();
    });
    const ve = a(() => {
      const l = e.groupByFunction;
      return l ? D.value.reduce((V, X) => {
        const se = l(X);
        return {
          ...V,
          [se]: [
            ...V[se] ?? [],
            X
          ]
        };
      }, {}) : {
        "": e.options
      };
    }), ye = a(() => [
      "or-select-v3",
      ...Oo,
      ...e.variant === Ke.Embedded ? ["grow"] : []
    ]), be = a(() => [
      ...Vo
    ]), he = a(() => [
      ...ko
    ]), Se = a(() => {
      var l;
      return [
        "or-select-popover-v3",
        ...A.value ? [] : [
          ...wo,
          ...(l = S.value) != null && l.isFlipped ? $o : Co
        ]
      ];
    }), ge = a(() => [
      A.value ? "layout-column" : "contains",
      le.value ? "overflow-y-auto" : "overflow-hidden"
    ]), Oe = a(() => [
      ...Mo,
      ...e.multiple ? Bo : Io,
      ...A.value ? To : []
    ]), Ve = a(() => [
      ...Eo
    ]), ke = a(() => [
      ...Po
    ]);
    function we() {
      !d.value && !e.disabled && S.value && (I.value === "open" && !R.value ? re() : (ne(), setTimeout(() => {
        Ce();
      })));
    }
    function ne() {
      const l = S.value;
      l && l.open();
    }
    function re() {
      const l = S.value;
      l && l.close();
    }
    function Ce() {
      if (U.value) {
        const l = A.value ? s.value : B.value ? h.value : O.value;
        l && l.focus();
      }
    }
    function $e(l) {
      e.multiple ? r.value = ie(l, x(r.value)) : r.value = l, Q();
    }
    function Me(l) {
      e.multiple ? r.value = ue(l, x(r.value)) : r.value = void 0;
    }
    function Ie(l) {
      if (e.multiple) {
        const V = x(r.value);
        V.includes(l) ? r.value = ue(l, V) : r.value = ie(l, V);
      } else
        r.value = r.value !== l ? l : void 0;
      Q();
    }
    function Q() {
      Re(() => {
        setTimeout(() => te.value = "");
      });
    }
    const { isDesktop: Be, isMobile: A } = ze();
    return {
      root: f,
      inputBox: v,
      inputBoxRoot: u,
      control: p,
      multipleControl: h,
      singleControl: O,
      searchControl: s,
      popover: S,
      popoverRoot: M,
      popoverState: I,
      rootStyles: ye,
      controlStyles: be,
      searchControlStyles: he,
      dropdownStyles: Se,
      dropdownContainerStyles: ge,
      dropdownItemStyles: Oe,
      noSearchResultsStyles: Ve,
      loaderStyles: ke,
      controlId: q,
      proxyModelValue: r,
      readonly: d,
      isEmptyModelValue: J,
      isOpen: P,
      showClear: t,
      searchText: te,
      internalSearchOptions: D,
      resolvedSearchOptions: K,
      groupedOptions: ve,
      toggle: we,
      close: re,
      open: ne,
      selectOption: $e,
      deselectOption: Me,
      toggleOption: Ie,
      resetSearch: Q,
      isDesktop: Be,
      isMobile: A
    };
  }
}), Ro = ["id", "disabled"], Do = {
  class: /* @__PURE__ */ y(["layout-inline-row", "gap-sm"])
}, Fo = {
  key: 0,
  class: /* @__PURE__ */ y(["px-sm+", "py-xs"])
}, Uo = ["onClick"];
function zo(e, o, w, f, v, u) {
  const p = i("OrLabel"), h = i("OrSelectMultipleControl"), O = i("OrSelectSingleControl"), s = i("OrIconButton"), S = i("OrIcon"), M = i("OrInput"), I = i("OrLoader"), P = i("OrCheckbox"), $ = i("OrMenuItem"), U = i("OrExpansionPanel"), c = i("OrPopover"), B = i("OrInputBox"), q = i("OrHint"), r = i("OrError"), le = de("dropdown-open"), J = de("dropdown-close");
  return n(), g("div", {
    ref: "root",
    class: y(e.rootStyles)
  }, [
    e.$slots.label || e.$slots.addon || e.label ? (n(), k(p, {
      key: 0,
      "control-id": e.controlId,
      variant: "input",
      required: e.required,
      disabled: e.disabled
    }, {
      addon: b(() => [
        C(e.$slots, "addon")
      ]),
      default: b(() => [
        C(e.$slots, "label", {}, () => [
          T(E(e.label), 1)
        ])
      ]),
      _: 3
    }, 8, ["control-id", "required", "disabled"])) : j("", !0),
    N((n(), k(B, {
      ref: "inputBox",
      class: y([e.popoverState === "open" && (e.popover && e.popover.isFlipped ? "rounded-t-0" : "rounded-b-0"), { "outline-none": e.variant === "embedded" }]),
      variant: e.variant,
      size: e.size,
      invalid: !!e.error,
      readonly: e.readonly,
      disabled: e.disabled,
      "force-state": e.isOpen ? "focus-within" : void 0,
      tabindex: e.disabled ? null : 0
    }, {
      default: b(() => [
        z("div", {
          id: e.controlId,
          ref: "control",
          class: y(e.controlStyles),
          disabled: e.disabled,
          onFocus: o[3] || (o[3] = (t) => e.$emit("focus", t)),
          onBlur: o[4] || (o[4] = (t) => e.$emit("blur", t))
        }, [
          C(e.$slots, "valueTemplate", { model: e.proxyModelValue }, () => [
            e.multiple ? (n(), k(h, {
              key: 0,
              ref: "multipleControl",
              modelValue: e.searchText,
              "onUpdate:modelValue": o[0] || (o[0] = (t) => e.searchText = t),
              model: e.proxyModelValue,
              options: e.options,
              overflow: e.overflow,
              placeholder: e.placeholder,
              readonly: e.readonly,
              disabled: e.disabled,
              "enable-search": e.enableSearch,
              "is-open": e.popoverState === "open",
              onReset: o[1] || (o[1] = (t) => e.deselectOption(t))
            }, {
              tag: b(({ item: t }) => [
                C(e.$slots, "tag", { item: t })
              ]),
              _: 3
            }, 8, ["modelValue", "model", "options", "overflow", "placeholder", "readonly", "disabled", "enable-search", "is-open"])) : (n(), k(O, {
              key: 1,
              ref: "singleControl",
              modelValue: e.searchText,
              "onUpdate:modelValue": o[2] || (o[2] = (t) => e.searchText = t),
              model: e.proxyModelValue,
              options: e.options,
              placeholder: e.placeholder,
              disabled: e.disabled,
              "enable-search": e.enableSearch,
              "is-open": e.popoverState === "open"
            }, null, 8, ["modelValue", "model", "options", "placeholder", "disabled", "enable-search", "is-open"]))
          ])
        ], 42, Ro),
        z("div", Do, [
          e.showClear ? (n(), k(s, {
            key: 0,
            icon: "close",
            color: "inherit",
            "additional-styles": ["!text-outline", "!dark:text-outline-dark"],
            disabled: e.readonly || e.disabled,
            onClick: o[5] || (o[5] = Y((t) => e.$emit("update:modelValue", e.multiple ? [] : void 0), ["stop"]))
          }, null, 8, ["disabled"])) : j("", !0),
          N(L(S, {
            icon: e.popoverState === "open" ? e.enableSearch ? "search" : "arrow_drop_up" : "arrow_drop_down",
            class: y(e.popoverState === "open" && e.enableSearch ? "!text-outline !dark:text-outline-dark" : ""),
            variant: "outlined"
          }, null, 8, ["icon", "class"]), [
            [Z, !(e.popoverState === "open" && e.enableSearch && e.enableClear && !e.isEmptyModelValue)]
          ])
        ]),
        L(c, {
          ref: "popover",
          variant: "auto",
          trigger: e.anchor || e.inputBoxRoot,
          placement: "bottom",
          offset: 0,
          "full-width": !0,
          "disable-default-styles": !0
        }, {
          default: b(() => [
            z("div", {
              class: y(e.dropdownStyles)
            }, [
              e.popoverState === "open" && e.enableSearch && e.isMobile ? (n(), k(M, {
                key: 0,
                ref: "searchControl",
                modelValue: e.searchText,
                "onUpdate:modelValue": o[6] || (o[6] = (t) => e.searchText = t),
                class: y(e.searchControlStyles),
                type: "search",
                placeholder: e.placeholder
              }, null, 8, ["modelValue", "class", "placeholder"])) : j("", !0),
              z("div", {
                class: y(e.dropdownContainerStyles)
              }, [
                e.loading ? (n(), g("div", Fo, [
                  C(e.$slots, "loading", {}, () => [
                    L(I, {
                      class: y(e.loaderStyles),
                      variant: "text",
                      text: e.loadingText
                    }, null, 8, ["class", "text"])
                  ])
                ])) : e.resolvedSearchOptions.length > 0 ? (n(), g(F, { key: 1 }, [
                  e.groupByFunction ? (n(!0), g(F, { key: 0 }, H(e.groupedOptions, (t, R) => (n(), k(U, {
                    key: R,
                    label: R
                  }, {
                    default: b(() => [
                      e.multiple ? (n(!0), g(F, { key: 0 }, H(t, (d, D) => (n(), k($, {
                        key: D,
                        "tooltip-text": d.label,
                        selected: e.proxyModelValue && e.proxyModelValue.includes(d.value),
                        disabled: d.disabled
                      }, {
                        default: b(() => [
                          C(e.$slots, "optionTemplate", {
                            model: e.proxyModelValue,
                            option: d
                          }, () => [
                            L(P, {
                              modelValue: e.proxyModelValue,
                              "onUpdate:modelValue": o[7] || (o[7] = (K) => e.proxyModelValue = K),
                              value: d.value,
                              label: d.label,
                              "label-variant": "menu-item",
                              disabled: d.disabled
                            }, null, 8, ["modelValue", "value", "label", "disabled"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["tooltip-text", "selected", "disabled"]))), 128)) : (n(!0), g(F, { key: 1 }, H(t, (d, D) => (n(), k($, {
                        key: D,
                        class: y(e.dropdownItemStyles),
                        "tooltip-text": d.label,
                        selected: e.proxyModelValue === d.value,
                        disabled: d.disabled,
                        onClick: Y((K) => e.selectOption(d.value), ["stop"])
                      }, {
                        default: b(() => [
                          C(e.$slots, "optionTemplate", {
                            model: e.proxyModelValue,
                            option: d
                          }, () => [
                            T(E(d.label), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["class", "tooltip-text", "selected", "disabled", "onClick"]))), 128))
                    ]),
                    _: 2
                  }, 1032, ["label"]))), 128)) : (n(), g(F, { key: 1 }, [
                    e.multiple ? (n(!0), g(F, { key: 0 }, H(e.resolvedSearchOptions, (t, R) => (n(), k($, {
                      key: R,
                      "tooltip-text": t.label,
                      class: y(e.dropdownItemStyles),
                      selected: e.proxyModelValue && e.proxyModelValue.includes(t.value),
                      disabled: t.disabled,
                      onClick: Y((d) => !t.disabled && e.toggleOption(t.value), ["stop"])
                    }, {
                      default: b(() => [
                        L(P, {
                          "model-value": e.proxyModelValue,
                          value: t.value,
                          "label-variant": "menu-item",
                          disabled: t.disabled
                        }, {
                          default: b(() => [
                            z("div", {
                              onClick: (d) => !t.disabled && e.toggleOption(t.value)
                            }, [
                              C(e.$slots, "optionTemplate", {
                                model: e.proxyModelValue,
                                option: t
                              }, () => [
                                T(E(t.label), 1)
                              ])
                            ], 8, Uo)
                          ]),
                          _: 2
                        }, 1032, ["model-value", "value", "disabled"])
                      ]),
                      _: 2
                    }, 1032, ["tooltip-text", "class", "selected", "disabled", "onClick"]))), 128)) : (n(!0), g(F, { key: 1 }, H(e.resolvedSearchOptions, (t, R) => (n(), k($, {
                      key: R,
                      class: y(e.dropdownItemStyles),
                      selected: e.proxyModelValue === t.value,
                      "tooltip-text": t.label,
                      disabled: t.disabled,
                      onClick: Y((d) => {
                        e.selectOption(t.value), e.close();
                      }, ["stop"])
                    }, {
                      default: b(() => [
                        C(e.$slots, "optionTemplate", {
                          model: e.proxyModelValue,
                          option: t
                        }, () => [
                          T(E(t.label), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["class", "selected", "tooltip-text", "disabled", "onClick"]))), 128))
                  ], 64))
                ], 64)) : (n(), g("div", {
                  key: 2,
                  class: y(e.noSearchResultsStyles)
                }, [
                  C(e.$slots, "noSearchResultsTemplate", { searchText: e.searchText }, () => [
                    T(" No results ")
                  ])
                ], 2))
              ], 2)
            ], 2)
          ]),
          _: 3
        }, 8, ["trigger"])
      ]),
      _: 3
    }, 8, ["class", "variant", "size", "invalid", "readonly", "disabled", "force-state", "tabindex"])), [
      [le, e.toggle],
      [J, e.close]
    ]),
    e.$slots.hint || e.hint ? N((n(), k(q, {
      key: 1,
      disabled: e.disabled
    }, {
      default: b(() => [
        C(e.$slots, "hint", {}, () => [
          T(E(e.hint), 1)
        ])
      ]),
      _: 3
    }, 8, ["disabled"])), [
      [Z, !e.error]
    ]) : j("", !0),
    N(L(r, { disabled: e.disabled }, {
      default: b(() => [
        T(E(e.error), 1)
      ]),
      _: 1
    }, 8, ["disabled"]), [
      [Z, typeof e.error == "string" && e.error.length > 0]
    ])
  ], 2);
}
const sl = /* @__PURE__ */ G(Lo, [["render", zo]]);
export {
  sl as O
};
//# sourceMappingURL=OrSelect-Cnklh9us.mjs.map
